import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { getAvailableCommands } from '../../services/commandService';
import { commandsState } from '../../storage/commands';

function AvailableCommandsProvider() {
  const setCommands = useSetRecoilState(commandsState);

  useEffect(() => {
    const loadCommandTypes = async () => {
      const { commands } = await getAvailableCommands();
      if (commands) {
        setCommands(commands);
      }
    };
    loadCommandTypes();
  }, []);

  return null;
}

export default AvailableCommandsProvider;
